module.exports = __webpack_public_path__ + "img/greenimpactpioneer.6500ffd3.png";